import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import type {
  DashboardRecentActivityItemDto,
  ResponseDto,
  QueryParamsDto,
} from "@mimber/schema"
import { dashboardKeys } from "../dashboard.utils"

export type UseDashboardRecentActivityParams = QueryParamsDto

export const useDashboardRecentActivity = (
  params?: UseDashboardRecentActivityParams,
  options?: UseQueryOptions<
    ResponseDto<DashboardRecentActivityItemDto[]>,
    Error
  >
): UseQueryResult<ResponseDto<DashboardRecentActivityItemDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useDashboardRecentActivity")

  const { server } = useServerContext()

  return useQuery({
    queryKey: dashboardKeys.getRecentActivity(params),
    queryFn: async () => {
      const response = await server.get<
        ResponseDto<DashboardRecentActivityItemDto[]>
      >(buildQueryString("dashboard/recent-activity", params))
      return response.data
    },
    staleTime: 1 * 60 * 1000,
    ...options,
  })
}
